import { Component, OnInit } from '@angular/core';
const swal = require('sweetalert');
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
@Component({
  selector: 'app-bulk-upload-files',
  templateUrl: './bulk-upload-files.component.html',
  styleUrls: ['./bulk-upload-files.component.scss']
})
export class BulkUploadFilesComponent implements OnInit {
  UploadFilebutton:boolean=false;
  file= new FormControl("", [Validators.required]);
  sMsg: string = '';
  MerchantKeyId:any;
  myFiles: string[] = [];
  isUploadFile: boolean = false;
  constructor(private commonfunction: CommonFunctionService,private service: PayoutService,private router: Router) { }

  ngOnInit() {
  }
  getFileDetails(e) {
    for (var i = 0; i < e.target.files.length; i++) {
      this.myFiles.push(e.target.files[i]);
    }
    if (this.myFiles.length != null) {
      this.isUploadFile = true;
      this.UploadFilebutton = true;
    }
    else {
      this.isUploadFile = true;
    }
  }


  uploadFiles() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    // form.UpdatedUserName = this.commonfunction.getUserId();
    this.MerchantKeyId = merchantdata.MerchantKeyId;
    const frmData = new FormData();
    // this.businessId = this.businessId;

    for (var i = 0; i < this.myFiles.length; i++) {
      frmData.append("fileUpload", this.myFiles[i]);
    }
    this.service.FileUpload(frmData,this.MerchantKeyId).subscribe(
      data => {
        if(data !=null)
        {
          this.sMsg = data as string;
          swal("Added", "File Uploaded Successfully", "success");
          this.router.navigate(["PayOut/ManagePayOutBulkUploadFiles"]);
        }
       
        // this.getAccountDatasList();
      });
    // this._router.navigate(['/home/addonBusiness/manage-business-account-data',{id :this.businessId}]);

    this.isUploadFile = false;
  }

  // LastNameerrors()
  // {
  //   return this.file.hasError("pattern") ? "File Type is Required" : "";
  // }

}
